import { apiRoutes } from '@/constants/api-routes';
import { apiRequest } from './http';
import type { EmailTemplateView } from '@/types/api';

export interface CreateTemplatePayload {
  name: string;
  subject: string;
  preheader?: string;
  format: 'html' | 'text';
  htmlBody?: string;
  textBody?: string;
}

export interface UpdateTemplatePayload {
  name?: string;
  subject?: string;
  preheader?: string;
  format?: 'html' | 'text';
  htmlBody?: string;
  textBody?: string;
}

export const adminEmailTemplatesService = {
  async list(): Promise<EmailTemplateView[]> {
    return apiRequest<EmailTemplateView[]>(apiRoutes.adminEmailTemplates.list, { method: 'GET' });
  },

  async getById(id: string): Promise<EmailTemplateView> {
    return apiRequest<EmailTemplateView>(apiRoutes.adminEmailTemplates.one(id), { method: 'GET' });
  },

  async create(payload: CreateTemplatePayload): Promise<EmailTemplateView> {
    return apiRequest<EmailTemplateView>(apiRoutes.adminEmailTemplates.create, {
      method: 'POST',
      body: payload,
    });
  },

  async update(id: string, payload: UpdateTemplatePayload): Promise<EmailTemplateView> {
    return apiRequest<EmailTemplateView>(apiRoutes.adminEmailTemplates.one(id), {
      method: 'PATCH',
      body: payload,
    });
  },

  async remove(id: string): Promise<void> {
    await apiRequest<void>(apiRoutes.adminEmailTemplates.one(id), { method: 'DELETE' });
  },
};
